
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { ProductPlanModel } from './Entities.GormCrm.ProductPlan';
import { Model, ModelProperty } from 'models/Model';


export class ProductPlanPreparationRequestModel extends Model<ProductPlanPreparationRequestModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'productPlan', type: 'ProductPlanModel', isHidden: true, isObject: true, new: () => { return new ProductPlanModel }, properties: () => { return ProductPlanModel.classProperties } },
		{ name: 'totalPlanValue', type: 'number' },
		{ name: 'accountingPlanSetupId', type: 'string' },
		{ name: 'departmentDimension', type: 'string' },
		{ name: 'companyDimension', type: 'string' },
		{ name: 'generatedFromSalesOrder', type: 'boolean' },
		{ name: 'generateInvoicesBasedOnProductPlanId', type: 'string' },
		{ name: 'startupAmount', type: 'number' },
		{ name: 'startupInstallments', type: 'number' },
		{ name: 'numberOfInstallments', type: 'number' }
	];
	[key: string]: any;
	
	public productPlan?: ProductPlanModel;
	public totalPlanValue: number;
	public accountingPlanSetupId?: string;
	public departmentDimension: string;
	public companyDimension: string;
	public generatedFromSalesOrder: boolean;
	public generateInvoicesBasedOnProductPlanId?: string;
	public startupAmount?: number;
	public startupInstallments?: number;
	public numberOfInstallments?: number;
    
	constructor(){
		super();
		this.productPlan = undefined;
		this.totalPlanValue = 0;
		this.accountingPlanSetupId = undefined;
		this.departmentDimension = '';
		this.companyDimension = '';
		this.generatedFromSalesOrder = false;
		this.generateInvoicesBasedOnProductPlanId = undefined;
		this.startupAmount = undefined;
		this.startupInstallments = undefined;
		this.numberOfInstallments = undefined;
		
	}
	getProperties(){
		return ProductPlanPreparationRequestModel.classProperties;
	}
}

